import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';
import { Field, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Radio } from 'web-ui-components/lib/atoms/forms';
import whoPaysContent, { contentPropTypes } from './whoPays.content';
import withContent from '../../../../containers/withContent';
import {
	whoPaysMapping,
	WHO_PAYS_TYPE_RECIPIENT,
	WHO_PAYS_TYPE_SHARED,
	WHO_PAYS_TYPE_YOU,
} from '../../../../config/ift';

const getInformationToHighlight = (selectedId, { whoPaysByYouInfo, whoPaysByReceipientInfo, whoPaysSharedInfo }) =>
	({
		[WHO_PAYS_TYPE_YOU]: whoPaysByYouInfo,
		[WHO_PAYS_TYPE_RECIPIENT]: whoPaysByReceipientInfo,
		[WHO_PAYS_TYPE_SHARED]: whoPaysSharedInfo,
	}[selectedId]);

export const WhoPaysSection = ({
	content: { header, description, ...otherContent },
	onChange,
	selectedId,
	disabled,
}) => (
	<Field>
		<FieldHeader name="who-pays" titleText={header} description={description} />
		<div>
			{whoPaysMapping.map(({ id, label }) => (
				<Radio
					key={id}
					id={id}
					block
					label={label}
					onChange={onChange}
					checked={id === selectedId}
					disabled={disabled}
				/>
			))}
		</div>
		<HighlightTile type="info">{getInformationToHighlight(selectedId, otherContent)}</HighlightTile>
	</Field>
);

WhoPaysSection.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	onChange: PropTypes.func.isRequired,
	selectedId: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
};
export default compose(withContent({ content: whoPaysContent }))(WhoPaysSection);
